import BaseApi from "./BaseApi";

export default class Users extends BaseApi {
    construct() {}

    static async search(params = {}) {
        return await Users.getAxiosInstance().get(Users.getApiUrl() + "/search", {
            params
        });
    }

    static async get(id) {
        return await Users.getAxiosInstance().get(Users.getApiUrl() + "/" + id);
    }

    static async all() {
        return await Users.getAxiosInstance().get(Users.getApiUrl() + "/get-all");
    }

    static async create(params) {
        return await Users.getAxiosInstance().post(Users.getApiUrl(), params);
    }

    static async update(params, id) {
        return await Users.getAxiosInstance().put(Users.getApiUrl() + "/" + id, params);
    }

    static async delete(id) {
        return await Users.getAxiosInstance().delete(Users.getApiUrl() + "/" + id);
    }

    static async getPermissions(id) {
        return await Users.getAxiosInstance().get(Users.getApiUrl() + "/" + id + "/permissions");
    }

    static async updatePermissions(id, params) {
        return await Users.getAxiosInstance().put(Users.getApiUrl() + "/" + id + "/permissions", params);
    }

    static async importPreview(params) {
        return await Users.getAxiosInstance().post(
            Users.getApiUrl() + "/import/preview",
            params
        );
    }

    static async importStore(params) {
        return await Users.getAxiosInstance().post(
            Users.getApiUrl() + "/import",
            params
        );
    }

    static async registerMicrosoftAccount(params) {
        return await Users.getAxiosInstance().post(
            Users.getApiUrl() + "/microsoft/register",
            params
        );
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "users";
    }
}